// Helpers pour la gestion des données RSE

const createRSEMetric = (name, unit, data, coef, isCount = false) => ({
  name,
  unit,
  score: data?.value || 0,
  approved: data?.approved || false,
  coef,
  goal: data?.objectif || 0,
  superior: data?.superior || false,
  isCount,
});

export const getCommonRSEStandards = (data) => [
  createRSEMetric(
    "Taux de réparation / remplacement des pièces",
    " %",
    data.tx_repair,
    2
  ),
  createRSEMetric("Taux de PRE", " %", data.tx_PRE, 1.5),
  createRSEMetric("Taux de PQE", " %", data.tx_PQE, 0.5),
  createRSEMetric(
    "Jours de formation",
    " jours",
    data.nb_formation_days,
    1,
    true
  ),
];

export const formatRSEData = (data) => {
  const standards = [
    ...getCommonRSEStandards(data),
    createRSEMetric("Taux de VEI", " %", data.tx_VEI, 1.5),
    createRSEMetric(
      "Delai entre la visite terrain et le dépot du dossier",
      " jours",
      data.delay_visit_to_deposit,
      1
    ),
    createRSEMetric(
      "Taux d'expertise au cabinet",
      " %",
      data.tx_expertise_cabinet,
      1.5
    ),
    createRSEMetric(
      "Taux de dossiers avec visite en cours de travaux",
      " %",
      data.tx_visit_works,
      1.5
    ),
  ];

  return {
    ...standards,
    value: data.value,
    value_globale: data.value_globale,
    value_month: data.value_month,
    value_month_globale: data.value_month_globale,
    global: data.global,
    gradeName: data.gradeName,
  };
};

export const formatRSEDataEAD = (data) => {
  const standards = [
    ...getCommonRSEStandards(data),
    createRSEMetric(
      "Taux de passage en terrain",
      " %",
      data.tx_transit_to_field,
      2
    ),
    createRSEMetric(
      "Delai entre la date d'EAD et le dépot du dossier",
      " jours",
      data.delay_EAD_to_deposit,
      1
    ),
  ];

  return {
    ...standards,
    value: data.value,
    value_globale: data.value_globale,
    value_month: data.value_month,
    value_month_globale: data.value_month_globale,
    global: data.global,
    gradeName: data.gradeName,
  };
};

export const RSE_PROPERTIES = [
  "tx_repair",
  "tx_PRE",
  "tx_PQE",
  "nb_formation_days",
  "delay_visit_to_deposit",
  "tx_expertise_cabinet",
  "tx_visit_works",
];

export const RSE_PROPERTIES_EAD = [
  "tx_repair",
  "tx_PRE",
  "tx_PQE",
  "nb_formation_days",
  "tx_transit_to_field",
  "delay_EAD_to_deposit",
];

export const hasAllRequiredProperties = (data, properties) => {
  return properties.every((prop) => data.hasOwnProperty(prop));
};
